var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculator"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.167 6.5L7.16699 17.5M9.16699 10.5V6.5M7.16699 8.5H11.167M14.167 15.5H18.167M8.46699 21H16.867C18.5471 21 19.3872 21 20.029 20.673C20.5934 20.3854 21.0524 19.9265 21.34 19.362C21.667 18.7202 21.667 17.8802 21.667 16.2V7.8C21.667 6.11984 21.667 5.27976 21.34 4.63803C21.0524 4.07354 20.5934 3.6146 20.029 3.32698C19.3872 3 18.5472 3 16.867 3H8.46699C6.78683 3 5.94676 3 5.30502 3.32698C4.74053 3.6146 4.28159 4.07354 3.99397 4.63803C3.66699 5.27976 3.66699 6.11984 3.66699 7.8V16.2C3.66699 17.8802 3.66699 18.7202 3.99397 19.362C4.28159 19.9265 4.74053 20.3854 5.30502 20.673C5.94676 21 6.78683 21 8.46699 21Z",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.6f64e8a70c1dca787cdee71716bc81a0.svg";
export { ForwardRef as ReactComponent };